"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warning = exports.transparent = exports.secondary = exports.primaryWash = exports.primary = exports.positive = exports.negative = exports.lineHeavy = exports.line = void 0;
require("./borderColor.css");
/**
 * DO NOT MODIFY
 * Generated from scripts/codegen/main.ts
 */

const primary = "cds-primary-p14ir8og";
exports.primary = primary;
const primaryWash = "cds-primaryWash-pvkh26q";
exports.primaryWash = primaryWash;
const secondary = "cds-secondary-s13tpdt0";
exports.secondary = secondary;
const positive = "cds-positive-p1k3nabz";
exports.positive = positive;
const negative = "cds-negative-n1aoh4ot";
exports.negative = negative;
const line = "cds-line-lm9v2nm";
exports.line = line;
const lineHeavy = "cds-lineHeavy-l1evesva";
exports.lineHeavy = lineHeavy;
const transparent = "cds-transparent-tlx9nbb";
exports.transparent = transparent;
const warning = "cds-warning-w1tr5pg2";
exports.warning = warning;